export default "__VITE_ASSET__DDTU4PCO__"